import $ from 'jquery';

const $html = $('html');
const $toggleMobile = $('.btn-toggle-nav');
const $menuMobile = $('.nav-wrapper');
const $liveRegion = $('.live-region');

// Traductions
const translations = {
    en: {
        menuOpened: 'Menu opened',
        menuClosed: 'Menu closed',
    },
    fr: {
        menuOpened: 'Menu ouvert',
        menuClosed: 'Menu fermé',
    },
};

const open = () => {
    $toggleMobile.addClass('is-open');
    $toggleMobile.attr('aria-expanded', true);
    $menuMobile.addClass('is-open');
    $html.addClass('menu-open');
    const $menuMobileHeight = $('div[data-sitewide-alert]').height() + $('.header').height();
    $liveRegion.text(translations.menuOpened);
    $menuMobile.css({
        height: `calc(100vh - ${$menuMobileHeight}px)`,
    });
};
const close = () => {
    $toggleMobile.removeClass('is-open');
    $toggleMobile.attr('aria-expanded', false);
    $menuMobile.removeClass('is-open');
    $html.removeClass('menu-open');
    $liveRegion.text(translations.menuClosed);
};

$toggleMobile.on('click', () => {
    if ($toggleMobile.hasClass('is-open')) {
        close();
    } else {
        open();
    }
});
$(window).on('resize', (e) => {
    const $windowWidth = $(e.currentTarget).width();
    if ($windowWidth > 1024) {
        close();
        $menuMobile.css({
            height: 'auto',
        });
    }
});
$(document).on('click', (e) => {
    if (!$(e.target).closest($menuMobile).length
    && !$(e.target).closest($toggleMobile).length) {
        close();
    }
});
$(document).on('focusin', (e) => {
    if (!$(e.target).closest($menuMobile).length
    && !$(e.target).closest($toggleMobile).length) {
        close();
    }
});
